/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_DescriptionInputs */



/**
* | output |
* | --- |
* | "Description" |
*
* @param {Explorer_Info_Property_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_description = /** @type {((inputs?: Explorer_Info_Property_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description")
	if (locale === "de") return /** @type {LocalizedString} */ ("Description")
	if (locale === "it") return /** @type {LocalizedString} */ ("Description")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Description")
	if (locale === "es") return /** @type {LocalizedString} */ ("Description")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Description")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Description")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Description")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Description")
	return /** @type {LocalizedString} */ ("Description")
});